"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var platform_1 = tslib_1.__importDefault(require("platform"));
var Utils = tslib_1.__importStar(require("../util/utils"));
var logger_1 = tslib_1.__importDefault(require("../util/logger"));
var defaults_1 = tslib_1.__importDefault(require("../util/defaults"));
var auth_1 = tslib_1.__importDefault(require("./auth"));
var push_1 = tslib_1.__importDefault(require("./push"));
var platform_http_1 = tslib_1.__importDefault(require("platform-http"));
var paginatedresource_1 = tslib_1.__importDefault(require("./paginatedresource"));
var channel_1 = tslib_1.__importDefault(require("./channel"));
var errorinfo_1 = tslib_1.__importDefault(require("../types/errorinfo"));
var stats_1 = tslib_1.__importDefault(require("../types/stats"));
var HttpMethods_1 = tslib_1.__importDefault(require("../../constants/HttpMethods"));
var noop = function () { };
var msgpack = platform_1["default"].msgpack;
var Rest = /** @class */ (function () {
    function Rest(options) {
        if (!options) {
            var msg = 'no options provided';
            logger_1["default"].logAction(logger_1["default"].LOG_ERROR, 'Rest()', msg);
            throw new Error(msg);
        }
        var optionsObj = defaults_1["default"].objectifyOptions(options);
        if (optionsObj.log) {
            logger_1["default"].setLog(optionsObj.log.level, optionsObj.log.handler);
        }
        logger_1["default"].logAction(logger_1["default"].LOG_MICRO, 'Rest()', 'initialized with clientOptions ' + Utils.inspect(options));
        var normalOptions = (this.options = defaults_1["default"].normaliseOptions(optionsObj));
        /* process options */
        if (normalOptions.key) {
            var keyMatch = normalOptions.key.match(/^([^:\s]+):([^:.\s]+)$/);
            if (!keyMatch) {
                var msg = 'invalid key parameter';
                logger_1["default"].logAction(logger_1["default"].LOG_ERROR, 'Rest()', msg);
                throw new errorinfo_1["default"](msg, 40400, 404);
            }
            normalOptions.keyName = keyMatch[1];
            normalOptions.keySecret = keyMatch[2];
        }
        if ('clientId' in normalOptions) {
            if (!(typeof normalOptions.clientId === 'string' || normalOptions.clientId === null))
                throw new errorinfo_1["default"]('clientId must be either a string or null', 40012, 400);
            else if (normalOptions.clientId === '*')
                throw new errorinfo_1["default"]('Can’t use "*" as a clientId as that string is reserved. (To change the default token request behaviour to use a wildcard clientId, use {defaultTokenParams: {clientId: "*"}})', 40012, 400);
        }
        logger_1["default"].logAction(logger_1["default"].LOG_MINOR, 'Rest()', 'started; version = ' + defaults_1["default"].version);
        this.baseUri = this.authority = function (host) {
            return defaults_1["default"].getHttpScheme(normalOptions) + host + ':' + defaults_1["default"].getPort(normalOptions, false);
        };
        this._currentFallback = null;
        this.serverTimeOffset = null;
        this.http = new platform_http_1["default"]();
        this.auth = new auth_1["default"](this, normalOptions);
        this.channels = new Channels(this);
        this.push = new push_1["default"](this);
    }
    Rest.prototype.stats = function (params, callback) {
        /* params and callback are optional; see if params contains the callback */
        if (callback === undefined) {
            if (typeof params == 'function') {
                callback = params;
                params = null;
            }
            else {
                if (this.options.promises) {
                    return Utils.promisify(this, 'stats', arguments);
                }
                callback = noop;
            }
        }
        var headers = Utils.defaultGetHeaders(), format = this.options.useBinaryProtocol ? Utils.Format.msgpack : Utils.Format.json, envelope = this.http.supportsLinkHeaders ? undefined : format;
        if (this.options.headers)
            Utils.mixin(headers, this.options.headers);
        new paginatedresource_1["default"](this, '/stats', headers, envelope, function (body, headers, unpacked) {
            var statsValues = unpacked ? body : JSON.parse(body);
            for (var i = 0; i < statsValues.length; i++)
                statsValues[i] = stats_1["default"].fromValues(statsValues[i]);
            return statsValues;
        }).get(params, callback);
    };
    Rest.prototype.time = function (params, callback) {
        var _this = this;
        /* params and callback are optional; see if params contains the callback */
        if (callback === undefined) {
            if (typeof params == 'function') {
                callback = params;
                params = null;
            }
            else {
                if (this.options.promises) {
                    return Utils.promisify(this, 'time', arguments);
                }
            }
        }
        var _callback = callback || noop;
        var headers = Utils.defaultGetHeaders();
        if (this.options.headers)
            Utils.mixin(headers, this.options.headers);
        var timeUri = function (host) {
            return _this.authority(host) + '/time';
        };
        this.http["do"](HttpMethods_1["default"].Get, this, timeUri, headers, null, params, function (err, res, headers, unpacked) {
            if (err) {
                _callback(err);
                return;
            }
            if (!unpacked)
                res = JSON.parse(res);
            var time = res[0];
            if (!time) {
                _callback(new errorinfo_1["default"]('Internal error (unexpected result type from GET /time)', 50000, 500));
                return;
            }
            /* calculate time offset only once for this device by adding to the prototype */
            _this.serverTimeOffset = time - Utils.now();
            _callback(null, time);
        });
    };
    Rest.prototype.request = function (method, path, params, body, customHeaders, callback) {
        var useBinary = this.options.useBinaryProtocol, encoder = useBinary ? msgpack.encode : JSON.stringify, decoder = useBinary ? msgpack.decode : JSON.parse, format = useBinary ? Utils.Format.msgpack : Utils.Format.json, envelope = this.http.supportsLinkHeaders ? undefined : format;
        params = params || {};
        var _method = method.toLowerCase();
        var headers = _method == 'get' ? Utils.defaultGetHeaders(format) : Utils.defaultPostHeaders(format);
        if (callback === undefined) {
            if (this.options.promises) {
                return Utils.promisify(this, 'request', arguments);
            }
            callback = noop;
        }
        if (typeof body !== 'string') {
            body = encoder(body);
        }
        if (this.options.headers) {
            Utils.mixin(headers, this.options.headers);
        }
        if (customHeaders) {
            Utils.mixin(headers, customHeaders);
        }
        var paginatedResource = new paginatedresource_1["default"](this, path, headers, envelope, function (resbody, headers, unpacked) {
            return Utils.ensureArray(unpacked ? resbody : decoder(resbody));
        }, 
        /* useHttpPaginatedResponse: */ true);
        if (!Utils.arrIn(platform_http_1["default"].methods, _method)) {
            throw new errorinfo_1["default"]('Unsupported method ' + _method, 40500, 405);
        }
        if (Utils.arrIn(platform_http_1["default"].methodsWithBody, _method)) {
            paginatedResource[_method](params, body, callback);
        }
        else {
            paginatedResource[_method](params, callback);
        }
    };
    Rest.prototype.setLog = function (logOptions) {
        logger_1["default"].setLog(logOptions.level, logOptions.handler);
    };
    Rest.Promise = function (options) {
        options = defaults_1["default"].objectifyOptions(options);
        options.promises = true;
        return new Rest(options);
    };
    Rest.Callbacks = Rest;
    return Rest;
}());
var Channels = /** @class */ (function () {
    function Channels(rest) {
        this.rest = rest;
        this.all = {};
    }
    Channels.prototype.get = function (name, channelOptions) {
        name = String(name);
        var channel = this.all[name];
        if (!channel) {
            this.all[name] = channel = new channel_1["default"](this.rest, name, channelOptions);
        }
        else if (channelOptions) {
            channel.setOptions(channelOptions);
        }
        return channel;
    };
    /* Included to support certain niche use-cases; most users should ignore this.
     * Please do not use this unless you know what you're doing */
    Channels.prototype.release = function (name) {
        delete this.all[String(name)];
    };
    return Channels;
}());
exports["default"] = Rest;
